import LoyaltyDashboard from '../components/loyalty/LoyaltyDashboard';

export default function LoyaltyPage() {
  return <LoyaltyDashboard />;
}
